    export const sumarUnaHora = (hora) => {
        // Convertir el string a un objeto Date
        let fechaHora = new Date(`1970-01-01T${hora}:00`);

        // Añadir una hora
        fechaHora.setHours(fechaHora.getHours() + 1);

        // Obtener la hora y los minutos como strings con formato "hh:mm"
        let nuevaHora = fechaHora.toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' });

        // Devolver la nueva hora como string
        return nuevaHora;
    }

    export const sumarMinuto = (hora, min = 1) => {
        // Separar la hora y los minutos en variables separadas
        var partesHora = hora.split(":");
        var horas = parseInt(partesHora[0]);
        var minutos = parseInt(partesHora[1]);

        // Sumar un minuto a los minutos
        minutos += min;

        // Si los minutos superan los 59, incrementar la hora y ajustar los minutos
        if (minutos > 59) {
            horas += 1;
            minutos = minutos % 60;
        }

        // Ajustar las horas para mantener el formato "hh"
        horas = horas % 24;
        horas = horas < 10 ? "0" + horas : horas;

        // Ajustar los minutos para mantener el formato "mm"
        minutos = minutos < 10 ? "0" + minutos : minutos;

        // Devolver la hora sumada en formato "hh:mm"
        return horas + ":" + minutos;
    }